import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import Calendar from '@/corePagesModule/components/Calendar.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionDateInput',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const emits = __emit;

const rootRef = ref<HTMLElement | null>(null);
const calendarRef = ref<HTMLElement | null>(null);
const isOpen = ref(false);
const selectedDate = ref<Date | null>(parseDateValue(props.modelValue));
const calendarStyle = ref<Record<string, string>>({});

const displayValue = computed(() => formatDateValue(selectedDate.value));

watch(
  () => props.modelValue,
  (value) => {
    selectedDate.value = parseDateValue(value);
  }
);

/**
 * 値をローカル日付に変換する。
 * @param value - 変換対象
 */
function parseDateValue(value: string | number | null): Date | null {
  if (value == null || value === '') return null;

  const match = String(value)
    .trim()
    .match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (!match) return null;

  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (date.getFullYear() !== Number(year) || date.getMonth() !== Number(month) - 1 || date.getDate() !== Number(day)) return null;
  return date;
}

/**
 * 日付を保存用のYYYY-MM-DDに変換する。
 * @param date - 変換対象
 */
function formatDateValue(date: Date | null): string {
  if (!date) return '';
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * カレンダーの開閉を切り替える。
 */
const toggleCalendar = (): void => {
  isOpen.value = !isOpen.value;
};

/**
 * トリガー位置に合わせてカレンダーをviewport基準で配置する。
 */
const updateCalendarPosition = (): void => {
  const root = rootRef.value;
  if (!root) return;

  const rect = root.getBoundingClientRect();
  const width = Math.min(420, window.innerWidth - 16);
  const left = Math.min(Math.max(rect.left, 8), window.innerWidth - width - 8);
  const calendarHeight = calendarRef.value?.offsetHeight ?? 360;
  const bottomTop = rect.bottom + 4;
  const top = bottomTop + calendarHeight <= window.innerHeight - 8 ? bottomTop : Math.max(8, rect.top - calendarHeight - 4);

  calendarStyle.value = {
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
  };
};

/**
 * カレンダーの選択値を保存値へ反映する。
 * @param value - 選択日
 */
const updateSelectedDate = (value: Date | null): void => {
  selectedDate.value = value;
  emits('update:modelValue', formatDateValue(value));
  isOpen.value = false;
};

/**
 * コンポーネント外クリックでカレンダーを閉じる。
 * @param event - ポインターイベント
 */
const handlePointerDown = (event: PointerEvent): void => {
  const target = event.target as Node;
  if (rootRef.value?.contains(target) || calendarRef.value?.contains(target)) return;
  isOpen.value = false;
};

watch(isOpen, async (value) => {
  if (!value) return;
  await nextTick();
  updateCalendarPosition();
});

onMounted(() => {
  document.addEventListener('pointerdown', handlePointerDown);
  window.addEventListener('resize', updateCalendarPosition);
  window.addEventListener('scroll', updateCalendarPosition, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('pointerdown', handlePointerDown);
  window.removeEventListener('resize', updateCalendarPosition);
  window.removeEventListener('scroll', updateCalendarPosition, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootRef",
    ref: rootRef,
    class: "condition-date-input"
  }, [
    _createElementVNode("button", {
      class: "condition-date-input__trigger",
      type: "button",
      onClick: toggleCalendar
    }, [
      _createElementVNode("span", {
        class: _normalizeClass({ 'condition-date-input__placeholder': !displayValue.value })
      }, _toDisplayString(displayValue.value || _unref(t)('日付を選択')), 3),
      _createVNode(Mdi, { icon: "calendar_month" })
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "calendarRef",
            ref: calendarRef,
            class: "condition-date-input__calendar",
            style: _normalizeStyle(calendarStyle.value)
          }, [
            _createVNode(Calendar, {
              "model-value": selectedDate.value,
              "hide-time": "",
              "onUpdate:modelValue": updateSelectedDate
            }, null, 8, ["model-value"])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}
}

})